import React, { FunctionComponent, useEffect, useRef } from 'react'

import WebcamModule from '../Module'
import { VideoPropTypes } from '../types'

const Video: FunctionComponent<VideoPropTypes> = ({ className }: VideoPropTypes) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    WebcamModule.video = videoRef.current
  }, [])

  return <video autoPlay data-testid="SW-VR-Webcam" className={className} ref={videoRef} />
}

export default Video
